// src/pages/Home.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Home() {
  const [stats, setStats] = useState({ resumo: [], financeiro: null, fiscal: null });

  const getUserName = () => {
    try { return JSON.parse(localStorage.getItem('prospera_user') || '{}').name || 'Usuário'; }
    catch { return 'Usuário'; }
  };

  const getSaudacao = () => {
    const h = new Date().getHours();
    return h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite';
  };

  const getDataFormatada = () => {
    const d = ['Domingo','Segunda-feira','Terça-feira','Quarta-feira','Quinta-feira','Sexta-feira','Sábado'];
    const m = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
    const h = new Date();
    return d[h.getDay()] + ', ' + h.getDate() + ' de ' + m[h.getMonth()] + ' de ' + h.getFullYear();
  };

  const getMes = () => { const h = new Date(); return h.getFullYear() + '-' + String(h.getMonth()+1).padStart(2,'0'); };
  const fmt = (v) => new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL',maximumFractionDigits:0}).format(v||0);

  useEffect(() => {
    const load = async () => {
      try {
        const mes = getMes();
        const h = new Date();
        const di = mes + '-01';
        const df = mes + '-' + new Date(h.getFullYear(), h.getMonth()+1, 0).getDate();
        const [r1,r2,r3] = await Promise.allSettled([
          fetch('/api/oportunidades/resumo/status?mes_ano='+mes),
          fetch('/api/financeiro/resumo/'+mes),
          fetch('/api/notas-fiscais/estatisticas?data_inicio='+di+'&data_fim='+df)
        ]);
        const d1 = r1.status==='fulfilled' ? await r1.value.json() : null;
        const d2 = r2.status==='fulfilled' ? await r2.value.json() : null;
        const d3 = r3.status==='fulfilled' ? await r3.value.json() : null;
        setStats({ resumo: d1?.data||[], financeiro: d2?.success?d2.resumo:null, fiscal: d3?.success?d3.estatisticas:null });
      } catch(e) { console.error('Home load error:', e); }
    };
    load();
  }, []);

  const getCnt = (s) => { const i = stats.resumo.find(r=>r.status===s); return i ? parseInt(i.total) : 0; };
  const getVal = (s) => { const i = stats.resumo.find(r=>r.status===s); return i ? parseFloat(i.valor_total) : 0; };
  const totalOS = stats.resumo.reduce((s,r) => s + (parseInt(r.total)||0), 0);
  const faturado = getVal('faturado');
  const pendente = (stats.financeiro?.total_receber||0) - (stats.financeiro?.recebido||0);
  const aReceber = stats.financeiro?.total_receber || 0;
  const aPagar = stats.financeiro?.total_pagar || 0;
  const saldo = (stats.financeiro?.total_receber||0) - (stats.financeiro?.total_pagar||0);
  const fPend = stats.fiscal?.pendente?.quantidade || 0;
  const fLanc = stats.fiscal?.lancada?.quantidade || 0;
  const fTotal = fPend + fLanc;

  return (
    <div className="home-container">
      <section className="home-welcome">
        <div><h1 className="home-greeting">{getSaudacao()}, {getUserName().split(' ')[0]} 👋</h1><p className="home-date">{getDataFormatada()}</p></div>
        <div className="home-sync-status"><span className="sync-dot-home"></span>Sincronizado com Gestão Click</div>
      </section>
      <section className="home-quick-stats">
        <div className="home-quick-stat"><div className="home-qs-icon" style={{background:'var(--blue-bg)'}}>📋</div><div><div className="home-qs-value">{totalOS}</div><div className="home-qs-label">OS no Mês</div></div></div>
        <div className="home-quick-stat"><div className="home-qs-icon" style={{background:'var(--green-bg)'}}>💰</div><div><div className="home-qs-value home-qs-green">{fmt(faturado)}</div><div className="home-qs-label">Faturado</div></div></div>
        <div className="home-quick-stat"><div className="home-qs-icon" style={{background:'var(--red-bg)'}}>📉</div><div><div className="home-qs-value home-qs-red">{fmt(pendente)}</div><div className="home-qs-label">Pendente Receber</div></div></div>
        <div className="home-quick-stat"><div className="home-qs-icon" style={{background:'var(--amber-bg)'}}>🎯</div><div><div className="home-qs-value">{getCnt('faturado')}</div><div className="home-qs-label">OS Faturadas</div></div></div>
      </section>
      <section className="home-modules-grid">
        <Link to="/servicos" className="home-module-card home-mod-servicos home-mod-wide">
          <div className="home-mod-header"><div className="home-mod-icon" style={{background:'var(--blue-bg)'}}>📊</div><span className="home-mod-badge home-badge-active">Ativo</span></div>
          <div className="home-mod-title">Dashboard Serviços</div>
          <div className="home-mod-desc">Kanban de oportunidades, ordens de serviço e acompanhamento</div>
          <div className="home-mod-preview home-mod-preview-4">
            <div className="home-prev-item"><div className="home-prev-value">{getCnt('orcamento_enviado')}</div><div className="home-prev-label">Orçamentos</div></div>
            <div className="home-prev-item"><div className="home-prev-value home-prev-amber">{getCnt('aguardando_atendimento')}</div><div className="home-prev-label">Aguardando</div></div>
            <div className="home-prev-item"><div className="home-prev-value home-prev-blue">{getCnt('em_andamento')}</div><div className="home-prev-label">Em Andamento</div></div>
            <div className="home-prev-item"><div className="home-prev-value home-prev-green">{getCnt('faturado')}</div><div className="home-prev-label">Faturados</div></div>
          </div>
        </Link>
        <Link to="/financeiro" className="home-module-card home-mod-financeiro">
          <div className="home-mod-header"><div className="home-mod-icon" style={{background:'var(--green-bg)'}}>💰</div><span className={'home-mod-badge '+(saldo<0?'home-badge-alert':'home-badge-active')}>{saldo<0?'Déficit':'Positivo'}</span></div>
          <div className="home-mod-title">Dashboard Financeiro</div>
          <div className="home-mod-desc">Contas a pagar, receber e fluxo de caixa</div>
          <div className="home-mod-preview">
            <div className="home-prev-item"><div className="home-prev-value home-prev-green">{fmt(aReceber)}</div><div className="home-prev-label">A Receber</div></div>
            <div className="home-prev-item"><div className="home-prev-value home-prev-red">{fmt(aPagar)}</div><div className="home-prev-label">A Pagar</div></div>
            <div className="home-prev-item"><div className="home-prev-value" style={{color:saldo<0?'var(--red)':'var(--green)'}}>{fmt(saldo)}</div><div className="home-prev-label">Saldo</div></div>
          </div>
        </Link>
        <Link to="/relatorios" className="home-module-card home-mod-relatorios">
          <div className="home-mod-header"><div className="home-mod-icon" style={{background:'var(--purple-bg)'}}>📈</div><span className="home-mod-badge home-badge-info">{new Date().toLocaleDateString('pt-BR',{month:'short',year:'numeric'})}</span></div>
          <div className="home-mod-title">Relatórios Gerenciais</div>
          <div className="home-mod-desc">Performance, metas por canal e análise de resultados</div>
          <div className="home-mod-preview">
            <div className="home-prev-item"><div className="home-prev-value home-prev-purple">{fmt(faturado)}</div><div className="home-prev-label">Faturamento</div></div>
            <div className="home-prev-item"><div className="home-prev-value">{getCnt('faturado')}</div><div className="home-prev-label">OS Faturadas</div></div>
            <div className="home-prev-item"><div className="home-prev-value">{totalOS}</div><div className="home-prev-label">Total OS</div></div>
          </div>
        </Link>
        <Link to="/fiscal" className="home-module-card home-mod-fiscal">
          <div className="home-mod-header"><div className="home-mod-icon" style={{background:'var(--amber-bg)'}}>🧾</div><span className={'home-mod-badge '+(fPend>0?'home-badge-alert':'home-badge-active')}>{fPend>0?fPend+' pendente'+(fPend>1?'s':''):'OK'}</span></div>
          <div className="home-mod-title">Gestão Fiscal</div>
          <div className="home-mod-desc">Notas fiscais, lançamentos e conciliação</div>
          <div className="home-mod-preview">
            <div className="home-prev-item"><div className="home-prev-value">{fTotal}</div><div className="home-prev-label">Total Mês</div></div>
            <div className="home-prev-item"><div className="home-prev-value home-prev-green">{fLanc}</div><div className="home-prev-label">Lançadas</div></div>
            <div className="home-prev-item"><div className="home-prev-value home-prev-amber">{fPend}</div><div className="home-prev-label">Pendentes</div></div>
          </div>
        </Link>
        <Link to="/repositorio" className="home-module-card home-mod-arquivos">
          <div className="home-mod-header"><div className="home-mod-icon" style={{background:'rgba(6,182,212,0.1)'}}>🗄️</div><span className="home-mod-badge home-badge-active">Online</span></div>
          <div className="home-mod-title">Servidor de Arquivos</div>
          <div className="home-mod-desc">Documentos, contratos, certidões e modelos</div>
          <div className="home-mod-preview">
            <div className="home-prev-item"><div className="home-prev-value">10</div><div className="home-prev-label">Pastas</div></div>
            <div className="home-prev-item"><div className="home-prev-value">55</div><div className="home-prev-label">Subpastas</div></div>
            <div className="home-prev-item"><div className="home-prev-value home-prev-cyan">Ativo</div><div className="home-prev-label">Status</div></div>
          </div>
        </Link>
      </section>
      <footer className="home-footer">Prospera+ · Desenvolvido por Salatiel Pereira — GVS Tecnologia · salatiel@gvstecnologia.com.br · (16) 99411-6998</footer>
    </div>
  );
}
export default Home;
